import { render } from "./InputTextArea.vue?vue&type=template&id=68d2cf00&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=68d2cf00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d2cf00"]])

export default __exports__